import { render, staticRenderFns } from "./CardTransferToSelf.vue?vue&type=template&id=1b38637a"
import script from "./CardTransferToSelf.js?vue&type=script&lang=js&external"
export * from "./CardTransferToSelf.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports